export default __webpack_public_path__ + "static/media/lichen-planus-pigmentosus.30c8d060.JPG";